module.exports = __webpack_public_path__ + "img/arrow-down-c.555edac8.svg";